import { reactify } from '@zeiss/zui-react';
export const ZuiIconHardwareDevices2D = reactify('zui-icon-hardware-devices-2-d');
